module.exports = __webpack_public_path__ + "static/media/screenshot-portfolio.e26b0496.png";